__turbopack_context__.v({
  "container": "hwdwra_container",
  "error": "hwdwra_error",
  "message": "hwdwra_message",
  "scale": "hwdwra_scale",
  "scaleSection": "hwdwra_scaleSection",
});
